import { AnalyticsField } from '@/store/analytics/utils/enums'

import { ASSET_FIELD } from '@/const'

export const ANALYTICS_DELAY_TO_NOTIFICATE = 5

export const ANALYTICS_DATE_STORAGE_KEY = 'ANALYTICS_DATE'

export const ANALYTICS_PERIOD_NAMING = {
  day: 'Daily',
  week: 'Weekly',
  month: 'Monthly',
  quarter: 'Quarterly',
  year: 'Yearly',
}

export const ANALYTICS_CAPTIONS = {
  [AnalyticsField.DATE]: 'Date',

  [AnalyticsField.ROOT_ID]: 'Root',

  [AnalyticsField.ASSET_ID]: 'Asset',
  [AnalyticsField.ASSET_TYPE]: 'Asset Type',
  [AnalyticsField.ACCOUNT_ID]: 'Account',
  [AnalyticsField.ACCOUNT_TYPE]: 'Account Type',

  [AnalyticsField.CATEGORY_ACCOUNT_ID]: 'Category Account',
  [AnalyticsField.CATEGORY_ACCOUNT_TYPE]: 'Category Account Type',

  [AnalyticsField.CATEGORY]: 'Category',
  [AnalyticsField.SUBCATEGORY]: 'Subcategory',

  [AnalyticsField.POSITION_CLOSE]: 'Value',
  [AnalyticsField.POSITION_COST]: 'Cost',
  [AnalyticsField.POSITION_GAIN]: 'Gain',

  [AnalyticsField.D_POSITION_CLOSE]: 'Value Change',
  [AnalyticsField.D_POSITION_COST]: 'Cost Change',
  [AnalyticsField.D_POSITION_GAIN]: 'Gain Change',

  [AnalyticsField.AMOUNT]: 'Amount',
  [AnalyticsField.D_AMOUNT]: 'Amount Change',

  [AnalyticsField.ASSET_CLOSE]: 'Price',

  [AnalyticsField.VALUE_START]: 'Value Start',
  [AnalyticsField.CHANGE]: 'Change',
  [AnalyticsField.PERCENT_CHANGE]: '% Change',
  [AnalyticsField.CAPITAL_FLOW]: 'Capital Flow',
  [AnalyticsField.VALUE_END]: 'Value End',
  [AnalyticsField.IRR]: 'IRR',
  [AnalyticsField.MOIC]: 'Multiple (MOIC)',

  [AnalyticsField.REALIZED_GAIN]: 'Realized',
  [AnalyticsField.UNREALIZED_GAIN]: 'Unrealized',

  // Commitments
  [AnalyticsField.ACCOUNT]: 'Account',
  [AnalyticsField.ASSET]: 'Asset',
  [AnalyticsField.INCEPTION_DATE]: 'Inception Date',
  [AnalyticsField.ORIGINAL_COMMITMENT]: 'Original Commitment',
  [AnalyticsField.REMAINING_COMMITMENT]: 'Remaining Commitment',
  [AnalyticsField.INVESTED_CAPITAL]: 'Total Contributions',
  [AnalyticsField.RECALLABLE_CAPITAL]: 'Recallable Returned Capital',
  [AnalyticsField.RETURNED_CAPITAL]: 'Total Returned Capital',
  [AnalyticsField.INCOME]: 'Income',
  [AnalyticsField.TOTAL_DISTRIBUTION]: 'Total Distribution',
  [AnalyticsField.GAIN_LOSS]: 'Gain / (Loss)',
  [AnalyticsField.CURRENT_BALANCE]: 'Current Balance',
}

export const ANALYTICS_LIABILITIES_NAME = 'Liabilities'

export const COMPARED_FIELDS = {
  [AnalyticsField.ACCOUNT_ID]: ASSET_FIELD.NAME,
  [AnalyticsField.ACCOUNT_TYPE]: ASSET_FIELD.TYPE,
  [AnalyticsField.ASSET_ID]: ASSET_FIELD.NAME,
  [AnalyticsField.ASSET_TYPE]: ASSET_FIELD.TYPE,
}

export const CATEGORY_ACCOUNT_COMPARED_FIELDS = {
  [AnalyticsField.CATEGORY_ACCOUNT_ID]: ASSET_FIELD.NAME,
  [AnalyticsField.CATEGORY_ACCOUNT_TYPE]: ASSET_FIELD.TYPE,
}
